<template>
  <v-container id="my-groups" fluid tag="section">
    <v-overlay :value="isOverlayVisible">
      <v-progress-circular
        :size="70"
        :width="7"
        color="green"
        indeterminate
        class="spinner"
      />
    </v-overlay>
    <base-v-component
      heading="Manage Phone Numbers"
      sub-heading="Phone Numbers List"
    />
    <template>
      <v-toolbar flat color="transparent" class="actionbar">
        <v-btn
          color="primary"
          dark
          class="mb-2"
          @click="showTwilioProvisionDialog"
        >
          <v-icon small class="mr-2"> mdi-plus </v-icon>
          Add Twilio Number
        </v-btn>
        <add-twilio-number
          :is-visible="isAddTwilioProvisionNumberDialogVisible"
          :selected-clinic="selectedClinic"
          @on-submit="onTwilioProvisionSubmit"
          @on-close="hideTwilioProvisionDialog"
          @on-success="onTwilioProvisionSuccess"
          @on-error="onTwilioProvisionError"
          @on-spinner-hide="onSpinnerHide"
        />
      </v-toolbar>
    </template>
    <v-data-table :headers="phoneNumberHeaders"
                  :items="phoneNumbers"
                  sort-by="senderName"
                  class="elevation-1">
      <template v-slot:no-data>
        <p class="mb-4 mt-4">No phone Numbers to display</p>
        <v-btn color="primary" outlined class="mb-4" @click="initialize">
          Refresh
        </v-btn>
      </template>
      <template v-slot:[`item.deploy`]="{ item }">
        <v-simple-checkbox :value="item.isDeployed"
                           @click="_deployNumber(item)" />
      </template>

      <template v-slot:[`item.actions`]="{ item }">
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
      </template>

    </v-data-table>
    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <div class="py-3" />
  </v-container>
</template>

<script>
  /* eslint-disable */
import Api from "../../../modules/shared-module/api";

export default {
  name: "ManagePhoneNumbers",
  components: {
    AddTwilioNumber: () => import(
        "../../../modules/pos-admin-module/components/add-twilio-number/add-twilio-number.vue"
      ),
  },
  props: {
    selectedClinic: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    apiEndpoint: process.env.VUE_APP_API_BASE_URL,
    apiCode: process.env.VUE_APP_API_CODE,
    phoneNumberHeaders: [
      { text: "Phone Number", value: "PhoneNumber" },
      { text: "Name", value: "Name" },
      { text: 'Deploy', value: 'deploy', sortable: false },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    snackbar: false,
    notification: "Unknown",
    phoneNumbers: [{}],
    isOverlayVisible: false,
    selectedPhoneNumberToEdit: null,
    isPhoneEditMode: false,
    isPhoneDialogVisible: false,
    isAddTwilioProvisionNumberDialogVisible: false,
  }),

  watch: {
    selectedClinic: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.initialize();
        }
      }
    },
  },

  methods: {
    async initialize() {
      try {
        this.isOverlayVisible = true;
        await this.fetchPhoneNumbers();
        this.isOverlayVisible = false;
      } catch (error) {
        this.isOverlayVisible = false;
      }
    },

    async _deployNumber(numberItem) {
      // console.log('numberItem', numberItem);
      if (!numberItem.isDeployed) {
        this.isOverlayVisible = true;
        await Api.messagingService.private.deployNumber({
          SendNumber: numberItem.PhoneNumber,
          PracticeID: this.selectedClinic.Practice_ID
        })
        // selectedClinic.practice_ID
        this.initialize();
      } else {
        this.notification = "Already deployed!";
        this.snackbar = true;
      }
    },

    async fetchPhoneNumbers() {
      try {
        console.log('this.selectedClinic', this.selectedClinic)
        await Api.messagingService.private.fetchPhoneNumbers(this.selectedClinic.Practice_ID).then((x) => {
          this.phoneNumbers = x.data;
        });
        console.log(this.phoneNumbers);
      } catch (error) {
        this.isOverlayVisible = false;
      }
    },

    formatNumber(number) {
      let maskedNumber = "";
      maskedNumber = number.replace("+1", "").replace(/[^0-9,]+/g, "");
      maskedNumber = `+1 (${maskedNumber.slice(0, 3)}) ${maskedNumber.slice(
        3,
        6
      )}-${maskedNumber.slice(6, 10)}`;
      return maskedNumber;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = {
          id: -1,
          name: "",
          members: "-",
          messages: "-",
        };
        this.editedIndex = -1;
        this.selectedSenderID = 0;
        this.isFormDirty = false;
      });
    },

    showTwilioProvisionDialog() {
      this.isAddTwilioProvisionNumberDialogVisible = true;
    },
    onTwilioProvisionSubmit() {
      this.isOverlayVisible = true;
    },

    hideTwilioProvisionDialog() {
      this.isAddTwilioProvisionNumberDialogVisible = false;
    },

    onTwilioProvisionSuccess() {
      this.isOverlayVisible = false;
      this.hideTwilioProvisionDialog();
      this.notification = "Phone Added Successfully";
      this.snackbar = true;
      this.fetchPhoneNumbers();
    },

    onTwilioProvisionError() {
      this.isOverlayVisible = false;
    },

    onSpinnerHide() {
      this.isOverlayVisible = false;
    },

    showLoader() {
      this.isOverlayVisible = true;
    },

    hideLoader() {
      this.isOverlayVisible = false;
    },

    async deleteItem(item) {
      // eslint-disable-next-line no-alert
      if (window.confirm("Are you sure you want to delete this phone number?")) {
        if (item.SID) {
          try {
            await Api.messagingService.private.removeNumber(item.SID);
            this.notification = `Phone number resource ${item.SID} has been deleted.`;
            this.snackbar = true;
            await this.fetchPhoneNumbers();
          } catch (error) {
            this.notification = `Unable to delete the phone number resource ${item.SID}`;
            this.snackbar = true;
          }
        } else {
          this.notification = "Phone number SID not available";
          this.snackbar = true;
        }
      }
    },
  },
};
</script>


<style scoped>
.v-overlay.v-overlay--active.theme--dark {
  z-index: 300 !important;
}
.spinner {
  margin-left: 17rem;
}
@media only screen and (max-width: 968px) {
  .spinner {
    margin-left: 0;
  }
}
.elevation-1 {
  margin-top: 3rem !important;
}

.titleWrapper {
  margin-top: 4rem;
  margin-bottom: -1rem;
}

.actionbar {
  margin-bottom: -25px;
  display: flex !important;
  justify-content: flex-end !important;
}

.senderActions {
  display: flex;
  width: 100px;
  justify-content: space-between;
}
</style>
